module.exports = __webpack_public_path__ + "img/star_filled.49e94ab4.svg";